import getTranslation from '@/i18n/getTranslation'
export const LINK = {
  modifyPhone: `${
    window.serverConfig.consoleUrl.uc
  }/account/safety-settings/modify-phone`
}
/**
 * @MAP 计费信息MAP
 */
export const BILLING_TYPE_MAP = [
  {
    label: getTranslation('按配置'),
    value: 1
  },
  {
    label: getTranslation('包年包月'),
    value: 2
  },
  {
    label: getTranslation('按用量'),
    value: 4
  },
  {
    label: getTranslation('按次数'),
    value: 8
  },
  {
    label: getTranslation('抢占式实例'),
    value: 16
  }
]

export const IS_OR_NOT = [
  {
    label: getTranslation('全部'),
    value: null
  },
  {
    label: getTranslation('是'),
    value: 1
  },
  {
    label: getTranslation('否'),
    value: 0
  }
]

export const STATUS_MAP = [
  {
    value: null,
    label: getTranslation('全部')
  },
  {
    value: 1,
    label: getTranslation('生成中')
  },
  {
    value: 2,
    label: getTranslation('禁用')
  },
  {
    value: 3,
    label: getTranslation('启用')
  },
  {
    value: 4,
    label: getTranslation('未激活')
  },
  {
    value: 5,
    label: getTranslation('审批驳回')
  }
]

export const ISSUE_TEXT = {
  issue: {
    balance: getTranslation('可发放额度'),
    fee: getTranslation('代金券金额'),
    dialogTitle: getTranslation('发放信息'),
    dialogFee: getTranslation('发放代金券金额'),
    validtext: {
      valid1: getTranslation('请输入代金券金额'),
      valid2: getTranslation('代金券金额需大于0'),
      valid3: getTranslation('代金券金额不能超过可发放额度'),
      valid4: getTranslation(
        '代金券金额必须是大于或等于0的整数或小数，小数最多保留两位'
      )
    }
  },
  resend: {
    balance: `${getTranslation('可转赠券额')}${getTranslation('：')}`,
    fee: `${getTranslation('转赠金额')}${getTranslation('：')}`,
    dialogTitle: getTranslation('转赠信息'),
    dialogFee: getTranslation('券额转赠金额：'),
    validtext: {
      valid1: getTranslation('请输入转增金额'),
      valid2: getTranslation('转增金额需大于0'),
      valid3: getTranslation('转增金额不能超过可转增券额'),
      valid4: getTranslation(
        '转增金额必须是大于或等于0的整数或小数，小数最多保留两位'
      )
    }
  }
}
